const Form006EN = {
    stepName: {
        basicInfo: "Basic Information",
        activityList: "Activity Information",
        adjustmentDetail: "Adjustment Detail",
        adjustmentForm: "Adjustment Information and Budget",
        signature: "Signature",
        confirm: "Confirmation",
    },
    notes: {
        notesTitle: "Personal Information Collection Statement",
        // notesTitle: "Statement",
        notes: "Notes",
        // tips1: "1. All information of the e-Form contained herein shall be subject to the application form on the EDB website",
        // tipsUrl:
        //     "https://www.edb.gov.hk/en/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        // tips2: "2. For any reduction in the no. of eligible students, sessions and groups, etc., the approved grant will be adjusted accordingly. For any increase in the no. of the proposed items, the expenditure cannot exceed the approved grant. Any over-spending shall be borne by the organisation itself.",
        // tips3: "3. Please submit this application form with the project adjustment form (Appendix) and attach a copy of the original approved form for the respective activity. <b><u>Approval from EDB should be obtained before any adjustment is implemented</u></b>. In principle, the processing time is <b><u>10 working days</u></b> upon receipt of all the documents required for project adjustment. In addition, applications for project adjustments should be submitted <b><u>on or before 31 May of the school year</u></b>. Late applications will not be processed.",
        agreeTips:
            "I have read, understood and agreed to the above terms and conditions.",
        labelTips1:
            "Please provide relevant document(s) for adjustment(s) proposed under consensus with collaborating school(s), such as email from school(s) to NGO",
        labelTips2:
            "e.g.: No. of sessions decreased from 10 to 9 and no. of eligible students served increased from 100 to 120, etc.",
    },
    serial: {
        tips1: "(ⅰ)",
        tips2: "(ⅱ)",
        tips3: "(ⅲ)",
    },
    label: {
        info: {
            placeholder: "Please enter...",
        },
        activityName: "Name of Activity",
        basicInfoOption: {
            referenceNo: "Project Reference No.",
            organisationName: "Name of Organisation",
            projectTitle: "Project Title",
            title: "Signature Information",
            coordinatorTitle: "Title of project coordinator",
            coordinatorName: "Name of project coordinator",
            contactTitle: "Title of contact person",
            contactName: "Name of contact person",
            contactTel: "Contact tel. no.",
            faxNo: "Fax no.",
            date: "Date",
        },
        adjustmentDetailOption: {
            title: "Details of Adjustment",
            projectType: "Revised/Cancelled/Added",
            activityName: "Name of Activity",
            collaboratingSchoolName:
                "Name of Collaborating School (if applicable)",
            schoolSupportingFile: "School Supporting Document",
            adjustmentItem: "Adjustment item",
            revisedReason: "Reason(s) for adjustment",
            cancelledReason: "Reason(s) for cancelled",
            addedReason: "Reason(s) for added",
            revisedParticulars: "Details of adjustment",
            cancelledParticulars: "Details of cancelled",
            addedParticulars: "Details of added",
            others: "Others (Please specify)",
        },
        adjustmentFormOption: {
            referenceNo: "Project Reference No.",
            projectType: "Revised/Cancelled/Added",
            activityName: "Name of Activity",
            collaboratingSchoolName:
                "Name of Collaborating School (if applicable)",
            activityType: "Types of activity",
            activityTypeA: "Category A",
            activityTypeB: "Category B",
            activityTypeC: "Category C",
            brieflyDescribe:
                "Briefly describe the activity's objective, content and method(s) of evaluating effectiveness",
            brieflyDescribeMsg: "description",
            studentNumber:
                "Estimated no. of eligible students served (headcount):",
            primarySchool: "Primary school(Total)",
            secondarySchool: "Secondary school(Total)",
            NCSStudent: "NCS students",
            SENStudent: "SEN students",
            NACStudent: "NAC",
            studentDetail:
                "# NCS - Non-Chinese speaking; SEN - Special educational need; NAC - Newly arrived children",
            startDate: "Start date",
            endDate: "End date",
            ofGroupNumber: "No.of group(s)",
            tutorStudentRatio: "Tutor : Student ratio (per group)",
            tutor: "Tutor",
            student: "Student",
            groupActivities: "Activities per group: ",
            lesson: "Lesson",
            session: "Session",
            venue: "Venue",
            halfDayActivity: "Half-day activity",
            wholeDayActivity: "Whole-day activity",
            lessonUnit: "session(s)",
            sessionUnit: "hr(s) per session",
            halfWholeUnit: "time(s)",
            halfDayTips: "Not less than 4 hours",
            wholeDayTips: "Not less than 7 hours",
        },
        activityBudgetOption: {
            title: "Breakdown of the budget for the proposed activity",
            thTips: "(Please submit relevant quotation(s)/reference(s) for any adjustment)",
            personUnit: "person(s)",
            pleaseSpecify: "Please specify: ",
            othersPleaseSpecify: "Please specify: ",
            expenditureItems: "Expenditure items",
            budgetOfApproved: "Budget of Approved Activity",
            budgetOfApprovedUnit:
                "(Leave this column blank for newly added activity)",
            budgetOfRevised: "Budget of Activity to be {{projectType}}",
            projectType: "Revised/Added*",
            budgetOfRevisedUnit:
                "(Leave this column blank for cancelling an activity)",
            remarks: "Remarks",
            academicQualifications: "Academic Qualifications",
            remarksUnit:
                "e.g. If the activity to be added/revised is Type A – Learning Skills, please specify tutor's academic qualification",
        },
        chopAttachment: "Chop of NGO / NGO's Subsidiary Organisation",
    },
    table: {
        activityBudget: {
            tutorFee: "Tutor fee",
            socialWorkerFee: "Social worker fee",
            othersProfession: "Others",
            materialExpenses: "Material expenses",
            campAdmissionFee: "Camp/admission fee",
            studentMeal: "Student meal (only for whole-day outdoor activities)",
            activityTransportationFee: "Activity transportation fee",
            volunteersAllowance: "Volunteers allowance",
            others: "Others",
            totalExpenditure: "Total expenditure",
        },
    },
    select: {
        projectType: {
            revised: "Revised",
            cancelled: "Cancelled",
            added: "Added",
        },
        titleOption: {
            Mr: "Mr.",
            Ms: "Ms.",
            Miss: "Miss",
        },
        adjustmentItemAll: {
            studentNo: "No. of eligible student served",
            changeGroups: "Increase/decrease no. of groups",
            changeSessions: "Increase/decrease no. of sessions",
            changeHours: "Increase/decrease class hours",
            adjustBudget: "Adjust the approved budget",
            changeName: "Change activity name",
            changeContent: "Change content of activity (Including venue)",
            others: "Others (Please specify)",
            cancelActivity: "Cancel activity",
            addNewActivity: "Add new activity",
        },
        adjustmentItem: {
            revised: {
                studentNo: "No. of eligible student served",
                changeGroups: "Increase/decrease no. of groups",
                changeSessions: "Increase/decrease no. of sessions",
                changeHours: "Increase/decrease class hours",
                adjustBudget: "Adjust the approved budget",
                changeName: "Change activity name",
                changeContent: "Change content of activity (Including venue)",
                others: "Others (Please specify)",
            },
            cancelled: {
                cancelActivity: "Cancel activity",
            },
            added: {
                addNewActivity: "Add new activity",
            },
        },
        activityType: {
            tutorialService: "Tutorial service",
            learningSkillsTraining: "Learning skills training",
            selfConfidenceDevelopment: "Self-confidence development",
            socialCommunicationSkills: "Social & communication skills training",
            voluntaryService: "Voluntary service",
            leadershipTraining: "Leadership training",
            adventureActivities: "Adventure activities",
            languageTraining: "Language training",
            artCulturalActivities: "Art & cultural activities",
            sportsActivities: "Sports activities",
            visitsOutdoorActivities: "Visits/outdoor activities",
        },
        activityTypeOption: {
            A: {
                tutorialService: "Tutorial service",
                learningSkillsTraining: "Learning skills training",
                languageTraining: "Language training",
            },
            B: {
                artCulturalActivities: "Art & cultural activities",
                visitsOutdoorActivities: "Visits/outdoor activities",
                sportsActivities: "Sports activities",
            },
            C: {
                voluntaryService: "Voluntary service",
                socialCommunicationSkills:
                    "Social & communication skills training",
                selfConfidenceDevelopment: "Self-confidence development",
                leadershipTraining: "Leadership training",
                adventureActivities: "Adventure activities",
            },
        },
        positionType: {
            types1: "Grade 2 or above in 5 subjects in the Hong Kong Diploma of Secondary Education Examination (HKDSE), including Chinese, English and Mathematics; or\nPasses in 5 subjects in the Hong Kong Certificate of Education Examination (HKCEE), including Chinese, English (Syllabus B) and Mathematics;",
            types2: "Grade 3 or above in 5 subjects in the HKDSE, including Chinese, English and Mathematics; or\nPasses in Chinese, English and 2 Advanced Level (AL) subjects in the Hong Kong Advanced Level Examination (HKALE); or \nPasses in Chinese, English and 1 AL subject plus 2 Advanced Supplementary (AS) subjects in the HKALE;",
            types3: "Post-secondary college graduates (higher diploma); or Associate degree",
            types4: "University graduates",
            types5: "University graduates (major in Chinese)",
            types6: "University graduates (major in English)",
            types7: "University graduates (major in Mathematics)",
        },
    },
    errorMsg: {
        numberBetween: "Please enter an integer between {{number}}",
        betweenThisDate: "Please select a date between {{dateBetween}}",
        acdamicYear: "Please select the date within the school year",
        othersSpecify: "Please input a valid item",
        budget: "Please input a valid budget",
        studentTotal:
            "This field must be less than or equal to the {{fieldName}}",
        number: {
            min: "This column sum must be larger than 0",
        },
    },
    comma: ",",
    semicolon: ";",
};
export default Form006EN;
